import { t } from "@lingui/macro";

import { EmptyStateIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  VStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";

export const InviteFullMessage = () => {
  return (
    <VStack
      backgroundColor="surface-primary"
      padding={6}
      gap={2}
      alignItems={"center"}
    >
      <EmptyStateIcon width={88} height={88} />
      <Box maxWidth={230} marginLeft="auto" marginRight="auto">
        <Text
          textAlign="center"
          variant="mainHeading"
          numberOfLines={2}
        >{t`No available spots remain on this booking.`}</Text>
      </Box>
    </VStack>
  );
};
